import { getMerchantById } from '@nemuru-eng/js-api-client';

import UserInMerchantStructure from '@/entities/UserInMerchantStructure';
import { useCache } from '@/hooks/requests/useCache';
import { useUser } from '@/hooks/useUser';

export const useMerchantAcquisitionChannel = () => {
  const { userEntity } = useUser();

  const merchantId = userEntity instanceof UserInMerchantStructure ? userEntity.merchant.id : undefined;

  const { data: merchant, loading } = useCache(getMerchantById, merchantId ? { merchantId } : null);

  return {
    acquisitionChannel: merchant?.acquisitionChannel,
    merchantId,
    merchantLoading: loading,
  };
};
